<template>
  <div class="implement_assessment assessment">
    <div class="show">
      <div class="head">
        <img src="~@img/xueyezixun/public/showTitle.png" alt="">
        <p>{{data.gradeName}}-{{data.nameName}}阶段评估报告</p>
      </div>
      <div>
        <MessageTitle title="阶段学习任务"></MessageTitle>
        <div style="margin-top: 30px">
          <GradeDetail :id="data.studentTestScoreId" v-if="data.studentTestScoreId"></GradeDetail>
        </div>
      </div>
      <div>
        <MessageTitle title="阶段评估"></MessageTitle>
        <CircleName name="学科学习"></CircleName>
        <table>
          <tbody>
            <tr>
              <th>考核</th>
              <th>家长</th>
              <th>学生</th>
              <th>成长导师</th>
              <th>咨询师</th>
              <th>综合评分</th>
            </tr>
            <tr>
              <td>任务完成</td>
              <td>{{data.slStudentTc}}</td>
              <td>{{data.slStudentTc}}</td>
              <td>{{data.slTeacherTc}}</td>
              <td>{{data.slConsultantTc}}</td>
              <td>{{data.slComplexTc}}</td>
            </tr>
            <tr>
              <td>完成效果</td>
              <td>{{data.slParentCr}}</td>
              <td>{{data.slStudentCr}}</td>
              <td>{{data.slTeacherCr}}</td>
              <td>{{data.slConsultantCr}}</td>
              <td>{{data.slComplexCr}}</td>
            </tr>
          </tbody>
        </table>
        <CircleName name="学习习惯"></CircleName>
        <table>
          <tbody>
              <tr>
                <th>考核</th>
                <th>家长</th>
                <th>学生</th>
                <th>成长导师</th>
                <th>咨询师</th>
                <th>综合评分</th>
              </tr>
              <tr>
                <td>任务完成</td>
                <td>{{data.lhStudentTc}}</td>
                <td>{{data.lhStudentTc}}</td>
                <td>{{data.lhTeacherTc}}</td>
                <td>{{data.lhConsultantTc}}</td>
                <td>{{data.lhComplexTc}}</td>
              </tr>
              <tr>
                <td>完成效果</td>
                <td>{{data.lhParentCr}}</td>
                <td>{{data.lhStudentCr}}</td>
                <td>{{data.lhTeacherCr}}</td>
                <td>{{data.lhConsultantCr}}</td>
                <td>{{data.lhComplexCr}}</td>
              </tr>
          </tbody>
        </table>
        <CircleName name="路径条件"></CircleName>
        <table>
          <tbody>
          <tr>
            <th>考核</th>
            <th>家长</th>
            <th>学生</th>
            <th>成长导师</th>
            <th>咨询师</th>
            <th>综合评分</th>
          </tr>
          <tr>
            <td>任务完成</td>
            <td>{{data.pcStudentTc}}</td>
            <td>{{data.pcStudentTc}}</td>
            <td>{{data.pcTeacherTc}}</td>
            <td>{{data.pcConsultantTc}}</td>
            <td>{{data.pcComplexTc}}</td>
          </tr>
          <tr>
            <td>完成效果</td>
            <td>{{data.pcParentCr}}</td>
            <td>{{data.pcStudentCr}}</td>
            <td>{{data.pcTeacherCr}}</td>
            <td>{{data.pcConsultantCr}}</td>
            <td>{{data.pcComplexCr}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <SummaryTitle title="整体评估"></SummaryTitle>
      <el-input type="textarea"  :value="data.overallAssess" disabled></el-input>
      <div class="bottom">
        <Button name="返回" @handleClick="jump"></Button>
      </div>
    </div>

  </div>
</template>

<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetail'
export default {
  name: "show",
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail },
  data(){
    return {
      data:{

      }
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.parent.student.implement.getStageAssessDetailByParent, {
        id:this.$route.query.assessmentId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.data=res.data.data
        }else{

        }
      })
    },
    jump(){
      this.$router.go(-1)
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
  @import "./css/index.less";
  .bottom{
    text-align: center;
    margin: 30px 0;
  }

</style>
<style lang="less">
  .implement_assessment{
    textarea{
      min-height: 140px !important;
    }
  }
</style>